import React, {useState, useEffect} from 'react'
// import FindTalentCard from '../../../components/Cards/FindTalentCard'
import RecruiterCard from "../../../components/Cards/RecruiterCard"
import datas from '../../../datas/RecruiterData.json'
import ButtonHoverAnimated from '../../../../components/Buttons/ButtonHoverAnimated'
import { useDispatch, useSelector } from 'react-redux'
import { fetchCompanies } from '../../../../redux/companySlice'
import { useNavigate } from 'react-router-dom'


const TopCompanies = ({items}) => {
    // const [jobs, setJobs] = useState(datas)
    const dispatch = useDispatch()
    const { companies, loading, error } = useSelector((state) => state.company);
  const navigate = useNavigate()
    useEffect(() => {
      dispatch(fetchCompanies({location:"", category:"", keyword : "", limit : 10})); 
    }, [])

  return (
    <div className='w-full py-20 px-6 lg:px-20 xl:px-40  bg-cover'  >
      <div className="flex justify-between items-center mb-10">
          <h4 className='text-2xl lg:text-4xl font-bold text-start'>Des entreprises qui recrutent</h4>
          <ButtonHoverAnimated onClick={()=>navigate("recruteur")} className='flex px-3 md:px-4 py-1.5 md:py-2 border-2 border-primary-black font-semibold text-primary-black rounded-full text-sm md:text-base'>
            Voir tout
          </ButtonHoverAnimated>
      </div>
      <div className='grid xl:grid-cols-2 md:grid-cols-1 sm:grid-col-span-1 gap-6'>
        {
        companies?.data?.map((item)=>{
          return( 
            <RecruiterCard key={item.id} item={item} />
        )})
        }
    </div>
</div>
  )
}

export default TopCompanies